import { Col, Table } from 'antd';

import '../profilepage.less';

/** Багана тутамд ногдох тохиромжтой өргөн */
const COLUMN_WIDTH = 150;

/** Цөөн баганатай хүснэгт хэт нарийсахгүй байх доод өргөн */
const MIN_BODY_WIDTH = 440;

/**
 * Гэрээний нэг үйлчилгээний хэсэг.
 *
 * Дээр нь дүрс, нэр, богино тайлбар — доор нь тарифын хүснэгт. Ингэснээр
 * "энэ ямар үйлчилгээ вэ?" гэдэг нь тоонуудаас нүдээр тусдаа уншигдана.
 * Карт биш: бүх хэсэг нэг цагаан хуудсан дээр зөвхөн зураасаар хуваагдана.
 *
 * Хүснэгтүүд нарийхан тул хэсэг бүр нь `Col` — эх `Row` нь өргөн дэлгэц дээр
 * хоёр хэсгийг зэрэгцүүлж, хоосон зайг ашиглана.
 */
const ContractSection = ({ icon: Icon, title, description, columns, dataSource = [], summary }) => {
  // `rowKey`-д index дамжуулах нь antd-д deprecated тул түлхүүрийг урьдчилж өгнө
  const rows = dataSource.map((item, index) => ({ ...item, key: item?._id ?? `row-${index}` }));

  /*
   * Хүснэгт эзэмшигч баганынхаа бүх өргөнд сунавал багана хоорондын зай
   * хэтэрч, нэг мөрийн тоонуудыг нүдээр холбоход хэцүү болдог. Иймд багананыхаа
   * тоонд тохирсон өргөнд барина — илүү зай нь баруун талд үлдэнэ.
   */
  const bodyMaxWidth = Math.max(MIN_BODY_WIDTH, columns.length * COLUMN_WIDTH);

  return (
    <Col xs={24} xl={12}>
      {/* Зураас нь баганын gutter-т биш, агуулгын мөрөнд тэгшлэгдэхийн тулд дотор нь */}
      <section className="contract-section">
        <div className="contract-section__head">
          <span className="contract-section__icon" aria-hidden="true">
            <Icon />
          </span>
          <div className="contract-section__label">
            <h4 className="contract-section__title">{title}</h4>
            {description && <p className="contract-section__desc">{description}</p>}
          </div>
        </div>

        <div className="contract-section__body" style={{ maxWidth: bodyMaxWidth }}>
          <Table
            className="contract-table"
            size="small"
            columns={columns}
            dataSource={rows}
            pagination={false}
            summary={summary}
            scroll={{ x: 'max-content' }}
          />
        </div>
      </section>
    </Col>
  );
};

export default ContractSection;
